<div class="row g-0">
    <div class="col-12 col-lg-8">
        <div class="card-body">

            <form [formGroup]="form" novalidate (ngSubmit)="save()">
                <div class="form-group row">
                    <label class="col-12 col-lg-6 col-form-label">Payment type</label>
                    <div class="col-12 col-lg-6">
                        <div *ngFor="let type of paymentTypesCollection.getAll()" class="form-check">
                            <label class="form-check-label">
                                <input (click)="onChangePaymentType(type.id)"
                                    formControlName="payment_type_id"
                                    [value]="type.id"
                                    class="form-check-input"
                                    type="radio">
                                    {{type.name}}
                            </label>
                        </div>
                    </div>
                </div>

                <div class="form-group row"
                    *ngIf="form.controls.payment_type_id.value == 2 && (!form.controls['credit_terms'].disabled || (form.disabled && form.controls.credit_terms.value))">
                    <label class="col-12 col-lg-6 col-form-label">Credit terms</label>
                    <div class="col-12 col-lg-6">
                        <div class="input-group mb-3">
                            <input formControlName="credit_terms"
                                [ngClass]="getFormGroupErrorClasses(form.controls.credit_terms)" class="form-control"
                                aria-describedby="credit_terms">
                            <span class="input-group-text" id="credit_terms">Days</span>
                            <div class="invalid-feedback" *ngIf="showErrorBlock(form.controls.credit_terms)">
                                <p *ngIf="form.controls.credit_terms.errors">Credit terms field is invalid</p>
                            </div>
                        </div>
                        <small class="form-text text-muted">How many days will this company have to settle th invoice?</small>
                    </div>
                </div>

                <div class="form-group row">
                    <label class="col-12 col-lg-6 col-form-label">Invoice frequency</label>
                    <div class="col-12 col-lg-6">
                        <div class="input-group mb-3">
                            <input formControlName="invoice_frequency"
                                [ngClass]="getFormGroupErrorClasses(form.controls.invoice_frequency)"
                                class="form-control" aria-describedby="invoice_frequency">
                            <span class="input-group-text" id="invoice_frequency">Days</span>
                            <div class="invalid-feedback" *ngIf="showErrorBlock(form.controls.invoice_frequency)">
                                <p *ngIf="form.controls.invoice_frequency.errors">Invoice frequency field is invalid.</p>
                            </div>
                        </div>
                        <small class="form-text text-muted">How often are invoices sent? (How many days after each uplift?)</small>
                    </div>
                </div>

                <jft-submit-button *ngIf="user.canManageAdvanced()"
                    (onClick)="save()"
                    [loading]="form.disabled"
                    [class]="'btn btn-light mb-2'"
                    [disabled]="form.invalid || loading"
                    [ngbPopover]="getFirstFormGroupErrorLabel(form)" triggers="mouseenter:mouseleave" placement="left"
                    [title]="'Save'"
                    [loadingTitle]="'Saving'" triggers="mouseenter:mouseleave" placement="right">
                </jft-submit-button>
            </form>


        </div>
    </div>
    <div class="col-12 col-lg-4 bg-light border-start">
        <h3 class="card-header bg-light d-flex align-items-center min-height">
            <span class="fa-stack small me-1">
                <i class="fas fa-square fa-stack-2x"></i>
                <i class="fas fa-info fa-stack-1x fa-inverse"></i>
            </span> How It Works
        </h3>
        <div class="card-body">
            <p class="mb-0">Explain how the preffered payment conditions effect the comparative cost fo capital calcualtion.</p>
        </div>
    </div>
</div>
